<mg-configurator-steeringwheel-picker [formControl]="componentFormControl">
    <mg-configurator-steeringwheel-picker-option
        *ngFor="let option of options"
        [description]="option.label"
        [value]="option.id"
    >
    </mg-configurator-steeringwheel-picker-option>
</mg-configurator-steeringwheel-picker>
